<template>
  <div class="each-domain-wrap">
    <div class="input-button-row">
      <input type="text" 
        :value="domain.dom_name"
        disabled
      >
      <button class="delete-button" @click="$emit('delete-domain', domain.dom_id)">Delete</button>
      <button class="add-ssl-button" :class="{'hasCert': domain.dom_freecert}" :disabled="!!domain.dom_freecert" @click="emitDomainId">{{domain.dom_freecert? "SSL" : "Add SSL"}}</button>
    </div>
    <div class="message">
      {{domain.dom_freecert !== 1? domain.dom_freecert_message : ""}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    domain: Object
  },
  data () {
    return {
      oldDomain: ''
    }
  },
  methods: {
    emitDomainId () {
      this.$emit('add-ssl', this.domain.dom_id)
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.each-domain-wrap {
  display: flex;
  flex-direction: column;
  margin: 10px 0;
}
.input-button-row {
  display: flex;
}
.add-ssl-button {
  display: flex;
  justify-content: center;
  width: 100px;
}
.delete-button, .add-ssl-button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  outline: none;
  border: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
}
.delete-button {
  margin: 0 10px;
}
.add-ssl-button {
  background: var(--button-color-bright-red);
  color: white;
}
.add-ssl-button.hasCert {
  background: #21eb99;
}
.message {
  color: red;
  font-size: 0.7em;
  padding: 0 10px;
}
</style>